import Vue from 'vue'
import VueRouter from 'vue-router'
import cvRouter from './cv'
import jobRouter from './jobs'
import accountRouter from './account'
import communityRouter from './community'
import hackathon from './hackathon'
import aiFacesRouter from './aiFaces'
import operatingRouterList from './operating'
import transferStationRouter from './transfer-station'
import spaceRouterList from './space'
import { getRouteData, getPageType } from '@/assets/js/routeMap'
import liveRouter from './live'
import campaignRouter from './campaign'

import {
  toLogin,
  checkJWT,
  updateJWT,
  setupWebViewJavascriptBridge,
} from '@/assets/js/utils'
import { getWeChatConfig } from '@/assets/js/wx-sdk'
import api from '@/api/api-list'
//获取jwt里边的参数
import { getTUser } from '@/utils/utils'

import Cookies from 'js-cookie'

let moment = require('moment')

// 全局的方法
const gioSetPeople = async () => {
  let user = await checkJWT()
  if (user.Authorization) {
    let tokenPayload = JSON.parse(window.atob(user.Authorization.split('.')[1]))
    let res = await api.global.getGioData(tokenPayload.User.c_t)
    if (res.code === 1000) {
      gio('setUserId', res.data.user_id)
      gio('people.set', res.data)
    }
  } else {
    console.log('未登录')
  }
}
const setBaiDuPush = () => {
  if (process.env.VUE_APP_ENV === 'prod') {
    var _hmt = _hmt || []
    ;(function () {
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?2e28467a211ca17f7aadc13ddd78a879'
      hm.defer = true
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  }
}
const postMessageTrack = (trackMessageId) => {
  if (trackMessageId) {
    api.global.messageTrack({ track_message_id: trackMessageId })
  }
}
const shareByWeChat = async (description, info, link) => {
  let wx = await getWeChatConfig()
  let shareInfo = {
    title: '超级简历 WonderCV | 智能专业简历制作',
    imgUrl: 'https://files.wondercv.com/App%20Icon@2x.png',
    link: link || window.location.href,
    ...info,
  }
  let desc =
    description ||
    'HR 推荐的专业简历，手机电脑同步编辑，中英双语模板，名企精英都在用'
  let haveDesc = { ...shareInfo, desc }
  wx.onMenuShareAppMessage(haveDesc)
  wx.onMenuShareTimeline(shareInfo)
  return wx
}

const dealIosVersion = async (ios, version) => {
  if (ios) {
    setupWebViewJavascriptBridge((bridge) => {
      bridge.registerHandler('sendJwt', (data, responseCallback) => {
        if (data && data.t) {
          updateJWT({
            jwt: data.t,
            jwt_timestamp: data.t_at,
            cookieEndTime: moment().add(14, 'd').valueOf(),
          })
          return { Authorization: data.t }
        } else {
          updateJWT({}, 'remove')
          return { Authorization: '' }
        }
      })
    })
  } else {
    return checkJWT()
  }
}

Vue.use(VueRouter)
const routes = [
  ...cvRouter,
  ...jobRouter,
  ...accountRouter,
  ...communityRouter,
  ...hackathon,
  ...aiFacesRouter,
  ...operatingRouterList,
  ...transferStationRouter,
  ...spaceRouterList,
  ...liveRouter,
  ...campaignRouter,
]
const router = new VueRouter({
  mode: 'history',
  routes,
})
// 路由守卫
router.beforeEach(async (to, from, next) => {
  let isIos = to.query.client === 'ios'
  let iosVersion = to.query.version
  let unionId = to.query.miniprogram_unionid
  try {
    let data = await dealIosVersion(isIos, iosVersion)
    if (process.env.VUE_APP_ENV === 'local') {
      return next()
    }
    if (to.meta.isLogin && data && !data.Authorization && !unionId) {
      toLogin(to.path)
    } else {
      //没有c端账户&&有b账户&&不是去往选择身份页面 ，根据jwt创建c账户
      if (
        !getTUser().c_t &&
        !!getTUser().h_t &&
        to.name !== 'template-matches' &&
        !to.name?.includes('campaign')
      ) {
        createCvAccount({ to, from, next })
        return
      }
      next()
    }
  } catch (e) {
    next()
    console.log(e)
  }
})

router.afterEach(async (to, from) => {
  // let isIos = to.query.client === 'ios'
  // let iosVersion = to.query.version
  // await dealIosVersion(isIos, iosVersion)
  // let isLogin = to.meta.isLogin
  // await verifyLogin(isLogin)
  // 上报轨迹
  let routeData = getRouteData(to)
  let page_type = getPageType(to.name) || ''
  let referrer = {
    url: from.path !== '/' ? window.origin + from.path : window.referrer,
    title: '',
  }
  let url = {
    url: window.origin + to.path,
    title: '',
  }
  window.reportUserBrowseHistory(referrer, url, 'm_vue', page_type, routeData)

  setBaiDuPush()
  postMessageTrack(to.query.track_message_id)
  gioSetPeople().then((r) => console.log(r))
  if (to.meta.diffShare) {
    to.meta.shareByWx = shareByWeChat
  } else {
    shareByWeChat()
      .then((r) => (to.meta.wx = r))
      .catch((e) => console.log(e))
  }
})

// 根据jwt创建c账户
const createCvAccount = async ({ to, from, next }) => {
  /***
   * 不需要跳转求职意向的页面
   * 1. accountUserNewInvitation：app分享邀请新用户注册得会员
   * 2. groupInvitation：机构号邀请新用户注册得会员
   * ***/
  let dontNeedsetProfession = ['accountUserNewInvitation', 'groupInvitation']

  let data = {
    source: 'pc_browser',
  }
  api.auth.create_cv_account(data).then(async (res) => {
    //创建成功
    if (res.code === 1000) {
      let { jwt, jwt_timestamp, phone_is_bound } = res.data
      await updateJWT({
        jwt,
        jwt_timestamp,
      })
      if (dontNeedsetProfession.includes(to.name)) {
        next()
        return
      }
      if (phone_is_bound) {
        next('/template_matches/new')
      } else {
        window.location.href = `${window.location.origin}/bind-phone?account_type=cv_account`
      }
    } else {
      //创建失败，重新登录
      updateJWT({}, true)
      toLogin()
    }
  })
}

export default router
